enum SortSelection {
    RELEVANCE = "relevance",
    DOCUMENT_DATE_ASCENDING = "documentDateAscending",
    DOCUMENT_DATE_DESCENDING = "documentDateDescending",
    TITLE_ASCENDING = "titleAscending",
    TITLE_DESCENDING = "titleDescending"
}
  
export default SortSelection;